import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-list-categoria',
  templateUrl: './list-categoria.component.html',
  styleUrls: ['./list-categoria.component.scss']
})
export class ListCategoriaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
